import {RestAPI} from './proxies';

export const getPlayers = async (tournament, leagueID) => {
    try {
        const response = await RestAPI.get(`/api/players/${tournament}/${leagueID}`);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to get players: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const getPlayerBios = async (tournament) => {
    try {
        const response = await RestAPI.get(`/api/players/${tournament}/biosonly`);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to get player bios: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};

export const getPlayerHistory = async (tournament, leagueID, playerID) => {
    try {
        const response = await RestAPI.get(`/api/players/${tournament}/${leagueID}/${playerID}`);
        if (response.success) {
            return response['data'];
        } else {
            throw new Error(`Failed to get player history: ${response.error}`);
        }
    } catch (err) {
        throw err;
    }
};